import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Plus, Minus } from "lucide-react";
import clsx from "clsx";
import { Fade } from "react-awesome-reveal";

const ITEMS = Array.from({ length: 10 }, (_, i) => ({
  num: String(i + 1).padStart(2, "0"),
  qKey: `markets.faq.q${i + 1}`,
  aKey: `markets.faq.a${i + 1}`,
}));

function Faq() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(0);

  return (
    <section className="mt">
      <div className="glcontainer">
        <Fade triggerOnce direction="up" duration={700}>
        <h2 className="font-42-28 text-center">{t("markets.faq.title")}</h2>
        </Fade>

        <div className="mt-[35px] lg:mt-[64px] max-w-[1011px] mx-auto flex flex-col gap-[12px]">
          <Fade cascade triggerOnce direction="up" damping={0.05}>
          {ITEMS.map((item, i) => {
            const isOpen = open === i;
            const answer = t(item.aKey);
            return (
              <div
                key={item.qKey}
                className={clsx(
                  "rounded-[16px] px-[20px] py-[24px] lg:px-[32px] lg:py-[28px] transition-colors duration-200",
                  isOpen ? "bg-[#f8faff]" : "bg-white border border-[#eaeaea]"
                )}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-[16px] text-left"
                >
                  <span className="flex items-center gap-[12px] lg:gap-[16px]">
                    <span className="font-['Inter'] font-medium text-[14px] text-[#666666] shrink-0">
                      {item.num}
                    </span>
                    <span className="font-['Inter'] font-bold text-[16px] leading-[1.5] text-[#1c385f]">
                      {t(item.qKey)}
                    </span>
                  </span>
                  {isOpen ? (
                    <Minus className="w-[23px] h-[23px] text-[#1c385f] shrink-0" strokeWidth={1.5} />
                  ) : (
                    <Plus className="w-[23px] h-[23px] text-[#1c385f] shrink-0" strokeWidth={1.5} />
                  )}
                </button>
                {isOpen && answer && (
                  <p className="mt-[12px] font-['Inter'] font-normal text-[14px] leading-[1.5] text-[#435c7f]">
                    {answer}
                  </p>
                )}
              </div>
            );
          })}
          </Fade>
        </div>
      </div>
    </section>
  );
}

export default Faq;
